<template>
  <div class="d-flex align-center">
    <div
      class="entity-type-icon-container mr-2 d-flex justify-center rounded-circle flex-shrink-0"
      :class="ICON_COLORS_BY_ENTITY[entityType]"
    >
      <v-icon color="white" size="14">
        {{ ICONS_BY_ENTITY[entityType] }}
      </v-icon>
    </div>
    <div class="ma-0 pa-0 d-flex flex-column">
      <span
        v-snip="{ lines: 2, mode: 'css' }"
        class="ma-0 pr-2 font-size-12 blue-grey--text text--darken-3"
        >{{ entityName }}</span
      >
      <span
        v-if="date"
        class="ma-0 pa-0 font-size-12 blue-grey--text text--darken-1"
        >{{ date }}</span
      >
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import store from '@/store/index.js'

const ICONS_BY_ENTITY = {
  improvementIdea: 'mdi-lightbulb-outline',
  problemSolving: 'mdi-puzzle-outline',
  quickAction: 'mdi-lightning-bolt-outline',
}

const ICON_COLORS_BY_ENTITY = {
  improvementIdea: 'blue',
  problemSolving: 'red',
  quickAction: 'orange',
}

export default {
  name: 'EntityChip',

  props: {
    entityType: {
      type: String,
      required: true,
      validator: val => Boolean(ICON_COLORS_BY_ENTITY[val]),
    },
    date: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      ICONS_BY_ENTITY,
      ICON_COLORS_BY_ENTITY,
    }
  },

  computed: {
    entityName() {
      const organization = store.organization.getOrganization()
      const customName =
        organization?.customNamings?.[this.entityType]?.singular

      return (
        customName ||
        this.$t(`common.entity_type.${_.snakeCase(this.entityType)}`)
      )
    },
  },
}
</script>
<style lang="scss">
.chip:before {
  background-color: inherit !important;
}

.entity-type-icon-container {
  width: 32px;
  height: 32px;
}
</style>
